<main class="timeapp supplies" style="display: flex;  flex-direction: column; overflow: hidden;">
	<div class="document-list">
		<mat-list>
			@for (supplyEntry of supplies | async; track supplyEntry) {
				<mat-list-item>
					<div class="list-element">
						<div class="icon">
							<fa-icon *ngIf="supplyEntry.readyForExport && !supplyEntry.exported" [icon]="faFileExport"></fa-icon>
							<fa-icon *ngIf="supplyEntry.exported" [icon]="faBolt"></fa-icon>
						</div>
						<div class="supply-entry">
							<div class="article">
								{{ supplyEntry.articleNumber }}&nbsp;{{ supplyEntry.articleDescription }}
							</div>
							<div class="details">
								<span>
									{{ supplyEntry.quantity }}&nbsp;{{ supplyEntry.unit }}
								</span>
								<span>
									{{ supplyEntry.priceTotal }}
								</span>
							</div>
						</div>
						<button [matMenuTriggerFor]="supplyEntryActionMenu" mat-icon-button [matMenuTriggerData]="{supplyID: supplyEntry.rowID}">
							<mat-icon>more_vert</mat-icon>
						</button>
					</div>
				</mat-list-item>
				<mat-divider></mat-divider>
			}
		</mat-list>
	</div>
</main>

<footer class="timeapp documents">
	<a routerLink="/timeapp" style="color: white;">
		<mat-icon class="">
			arrow_back
		</mat-icon>
	</a>
	<mat-icon (click)="navigateToAddSupplyEntry()" class="icon-size">add</mat-icon>
</footer>

<mat-menu #supplyEntryActionMenu="matMenu">
	<ng-template let-supplyID="supplyID" matMenuContent>
		<button (click)="navigateToEdit(supplyID)" mat-menu-item>{{ 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.edit' | translate }}</button>
		<button (click)="deleteSupplyEntry(supplyID)" mat-menu-item>{{ 'MAIN_APP_TIME_PLUS.SUPPLY_ENTRY.delete' | translate }}</button>
	</ng-template>
</mat-menu>